export default "__VITE_ASSET__CD$o7wK1__"